import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

const rootElement = document.getElementById("root")!;

// Performance optimization: Immediate render for better LCP
const root = createRoot(rootElement);

// Enhanced error handling and app mounting
try {
  // Keep skeleton visible until React renders to avoid flash
  // The skeleton will be naturally replaced when React mounts
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // Dispatch event when app is mounted - use requestAnimationFrame for better timing
  requestAnimationFrame(() => {
    window.dispatchEvent(new CustomEvent('app:mounted'));
  });

} catch (error) {
  console.error('Error rendering React app:', error);
  window.dispatchEvent(new CustomEvent('app:error', { 
    detail: { 
      message: `React render error: ${error instanceof Error ? error.message : 'Unknown error'}`,
      error: error 
    } 
  }));
}

// Global error handlers to catch runtime errors
window.onerror = function(message, source, lineno, colno, error) {
  console.error('Global error:', { message, source, lineno, colno, error });
  window.dispatchEvent(new CustomEvent('app:error', { 
    detail: { 
      message: `Runtime error: ${message}`,
      source,
      lineno,
      colno,
      error 
    } 
  }));
  return false; // Don't prevent default error handling
};

window.onunhandledrejection = function(event) {
  console.error('Unhandled promise rejection:', event.reason);
  window.dispatchEvent(new CustomEvent('app:error', { 
    detail: { 
      message: `Promise rejection: ${event.reason}`,
      error: event.reason 
    } 
  }));
};
